import { useEffect, useState } from 'react';

const getScoreLabel = (score) => {
  if (score >= 90) return { label: 'Excellent',    color: '#22c55e', bar: '#22c55e',  bg: 'rgba(34,197,94,0.08)' };
  if (score >= 75) return { label: 'Great',        color: '#22c55e', bar: '#22c55e',  bg: 'rgba(34,197,94,0.08)' };
  if (score >= 60) return { label: 'Good start',   color: '#f59e0b', bar: '#f59e0b',  bg: 'rgba(245,158,11,0.08)' };
  if (score >= 40) return { label: 'Keep going',   color: '#f59e0b', bar: '#fbbf24',  bg: 'rgba(245,158,11,0.08)' };
  return               { label: 'Try again',      color: '#ef4444', bar: '#f87171',    bg: 'rgba(239,68,68,0.08)' };
};

const CopyScoreDisplay = ({ score, isNew = false, isDark = false, extraScores = null, feedback = '' }) => {
  const [animated, setAnimated] = useState(false);

  useEffect(() => {
    if (score !== null) {
      const t = setTimeout(() => setAnimated(true), 100);
      return () => clearTimeout(t);
    }
  }, [score]);

  if (score === null || score === undefined) return null;

  const { label, color, bar, bg } = getScoreLabel(score);
  const c = {
    head: isDark ? '#fafaf9' : '#1c1917',
    muted: isDark ? '#78716c' : '#a8a29e',
    sub: isDark ? '#57534e' : '#b4aca6',
    border: isDark ? '#2d2825' : '#e8e4df',
  };

  return (
    <div style={{
      borderRadius: 16,
      padding: '20px 22px',
      background: bg,
      border: `1.5px solid ${bar}30`,
      animation: 'fadeUp 0.4s ease-out both',
    }}>
      <style>{`
        @keyframes fadeUp { from{opacity:0;transform:translateY(8px);}to{opacity:1;transform:translateY(0);} }
      `}</style>

      {/* Score number + label */}
      <div style={{ display: 'flex', alignItems: 'flex-end', justifyContent: 'space-between', marginBottom: 16 }}>
        <div>
          <div style={{ fontSize: 10, fontWeight: 700, color: c.muted, textTransform: 'uppercase', letterSpacing: '0.08em', marginBottom: 4 }}>
            Copy Score
          </div>
          <div style={{ fontSize: 40, fontWeight: 800, color, letterSpacing: '-0.03em', lineHeight: 1 }}>
            {score}
            <span style={{ fontSize: 16, fontWeight: 500, color: c.muted, marginLeft: 2 }}>/100</span>
          </div>
        </div>
        <div style={{ fontSize: 13, fontWeight: 700, color, padding: '4px 12px', borderRadius: 99, background: `${bar}15` }}>
          {label}
        </div>
      </div>

      {/* Animated score bar */}
      <div style={{
        height: 6,
        borderRadius: 99,
        background: isDark ? 'rgba(255,255,255,0.06)' : 'rgba(0,0,0,0.06)',
        overflow: 'hidden',
      }}>
        <div style={{
          height: '100%',
          borderRadius: 99,
          background: bar,
          width: animated ? `${score}%` : '0%',
          transition: 'width 0.8s cubic-bezier(0.22, 1, 0.36, 1)',
        }} />
      </div>

      {/* Pass/fail indicator */}
      <p style={{ fontSize: 12, color: c.muted, marginTop: 12, lineHeight: 1.5 }}>
        {score >= 60
          ? 'Exercise passed — your progress has been saved.'
          : 'Score below 60 — review the framework and try a different approach.'}
      </p>

      {/* Extra dimension scores */}
      {extraScores && (
        <div style={{ marginTop: 16, paddingTop: 16, borderTop: `1px solid ${c.border}` }}>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(120px, 1fr))', gap: 10 }}>
            {Object.entries(extraScores).map(([key, val]) => (
              <div key={key} style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <span style={{ fontSize: 10, fontWeight: 700, color: c.muted, textTransform: 'uppercase', letterSpacing: '0.06em' }}>
                    {key.replace(/([A-Z])/g, ' $1').trim()}
                  </span>
                  <span style={{ fontSize: 11, fontWeight: 800, color: c.head }}>{val}</span>
                </div>
                <div style={{ height: 3, borderRadius: 99, background: isDark ? 'rgba(255,255,255,0.06)' : 'rgba(0,0,0,0.06)' }}>
                  <div style={{
                    height: '100%',
                    borderRadius: 99,
                    background: bar,
                    width: `${val}%`,
                    transition: 'width 0.6s ease 0.2s',
                  }} />
                </div>
              </div>
            ))}
          </div>
        </div>
      )}

      {/* Feedback */}
      {feedback && (
        <div style={{
          marginTop: 14,
          padding: '10px 14px',
          borderRadius: 10,
          background: isDark ? 'rgba(255,255,255,0.04)' : 'rgba(0,0,0,0.03)',
          fontSize: 12,
          color: c.sub,
          lineHeight: 1.6,
          fontStyle: 'italic',
        }}>
          "{feedback}"
        </div>
      )}
    </div>
  );
};

export default CopyScoreDisplay;
